import React from 'react'
import RHelmet from '../RHelmet'

const InfoPageLayout = ({meta, children}) => {
  return (
    <>
      <RHelmet {...meta} />
      <div className={`col-cen-cen flex-1 w-full pad-t-0x5 content-pad-h gap-2`}>
        {children}
      </div>
    </>
  )
}

export default InfoPageLayout